module.exports = __webpack_public_path__ + "static/media/SepaLogoEN.57411878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SepaLogoEN.jpg
// module id = 35
// module chunks = 1 2 3